/* @flow */
declare var GIT_VERSION: string

import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import MQ from 'vue-match-media'
import vuelidateErrorExtractor from 'vuelidate-error-extractor'
import Trend from 'vuetrend'
import 'typeface-open-sans'
import * as VueGoogleMaps from 'vue2-google-maps'
import humanizeString from 'humanize-string'

import store from './store'
import router from './router'
import {validationMessages} from './validations'
import {roles} from '@/utils/api'
import './axios'

import './styles/material-icons.css'
import './styles/basscss.css'
import 'animate.css/animate.min.css'

import AppWrapper from './AppWrapper.vue'
import InputErrorWrapper from '@/components/InputErrorWrapper'
import DataLoadingSkeleton from '@/components/DataLoadingSkeleton'
import OfflinePluginRuntime from 'offline-plugin/runtime'

if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log('GIT VERSION:              ' + GIT_VERSION)
  console.log('GIT NEW FRONTEND VERSION: ' + process.env.GIT_NEW_FRONTEND_VERSION)

  // Wait to install the service worker to make sure intial load is complete
  setTimeout(() => {
    OfflinePluginRuntime.install({
      // Set a global variable that is checked in router.afterEach()
      onUpdateReady: () => (window.serviceWorkerUpdateIsReady = true),
      // The router has triggered the update on a navigation event,
      // so go ahead and reload to use the new assets
      onUpdated: () => window.location.reload(),
    })
  }, 7000)
}

Vue.config.productionTip = false
Vue.use(MQ)
Vue.use(vuelidateErrorExtractor, {
  name: 'ErrorProvider',
  template: InputErrorWrapper,
  messages: validationMessages,
})
Vue.use(Trend)
Vue.use(VueGoogleMaps, {
  load: {key: 'AIzaSyBAuM2AUaMMz6BzF0H42QRmHa2fWK6VNSA'},
  installComponents: true,
})
Vue.component(DataLoadingSkeleton.name, DataLoadingSkeleton)
Vue.component('Grid', {
  functional: true,
  render: (createElement, {data, children}) => {
    if (!data.style) data.style = {}
    data.style.display = 'grid'
    return createElement('div', data, children)
  },
})
Vue.filter('roleText', function(value) {
  const role = roles.find(role => role.value === value) || {}
  return role.text || value
})
Vue.filter('humanize', value => humanizeString(value))

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  vuetify,
  store,
  router,
  render: h => h(AppWrapper),
  mq: {
    xs: '(max-width: 599px)',
    sm: '(min-width: 600px)',
    md_sm: '(min-width: 760px)',
    md: '(min-width: 1024px)',
    md_lg: '(min-width: 1200px)',
    lg: '(min-width: 1440px)',
    xl: '(min-width: 1920px)',
  },
})



// WEBPACK FOOTER //
// ./src/index.js